import { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { setFormErrors } from "../../helpers/util";
import HiddenToolFields from "../../components/HiddenToolFields";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./PlatserRekryteringsdjurMjolkproduktion.css";
import FormElement from "../../components/FormElement/FormElement";
import FormInput from "../../components/FormInput/FormInput";
import Wrapper from "../../components/Wrapper/Wrapper";
import ActionsBar from "../../components/ActionsBar/ActionsBar";
import ToolHeader from "../../components/ToolHeader/ToolHeader";

import Slider from "react-slick";
import useSavedResults from "../../helpers/useSavedResults";
import ResultSection from "../../components/results/ResultSection";
import Label from "../../components/form-elements/Label";
import InputWrapper from "../../components/form-elements/InputWrapper";
import ResultWrapper from "../../components/results/ResultWrapper";
import Tooltip from "../../components/Tooltip/Tooltip";
import FormSection from "../../components/FormSection/FormSection";
import InputColumn from "../../components/InputColumn/InputColumn";

const schema = yup.object({
  D3: yup.number().typeError("Endast numeriskt värde tillåtet"), // D3: Antal kor - mjölkande och sinkor
  D4: yup.number().typeError("Endast numeriskt värde tillåtet"), // D4: Max antal kalvningar per månad

  D6: yup.number().typeError("Endast numeriskt värde tillåtet"), // D6: Rekryterings %
  D7: yup.number().typeError("Endast numeriskt värde tillåtet"), // D7: X-tra för oförutsedda händelser
  D8: yup.number().typeError("Endast numeriskt värde tillåtet"), // D8: Genomsnittlig tillväxt per dag i gram
  D9: yup.number().typeError("Endast numeriskt värde tillåtet"), // D9: Vikt vid födelse
  D10: yup.number().typeError("Endast numeriskt värde tillåtet"), // D10: Ålder vid förmedling
  D11: yup.number().typeError("Endast numeriskt värde tillåtet"), // D11: Önskad vikt vid inkalvning
});

export default function PlatserRekryteringsdjurMjolkproduktion() {
  const [serverMessages, setServerMessages] = useState([]);
  const { displaySavedAlert } = useSavedResults();
  const [hasResults, setHasResults] = useState(
    window.wpObject.tool_data != null
  );
  const methods = useForm({
    defaultValues: {
      D3:
        window.wpObject?.tool_data?.data?.D3 != null
          ? window.wpObject.tool_data.data.D3
          : 0, // D3: Antal kor - mjölkande och sinkor
      D4:
        window.wpObject?.tool_data?.data?.D4 != null
          ? window.wpObject.tool_data.data.D4
          : 0, // D4: Max antal kalvningar per månad
      D6:
        window.wpObject?.tool_data?.data?.D6 != null
          ? window.wpObject.tool_data.data.D6
          : 0, // D6: Rekryterings %
      D7:
        window.wpObject?.tool_data?.data?.D7 != null
          ? window.wpObject.tool_data.data.D7
          : 0, // D7: X-tra för oförutsedda händelser
      D8:
        window.wpObject?.tool_data?.data?.D8 != null
          ? window.wpObject.tool_data.data.D8
          : 0, // D8: Genomsnittlig tillväxt per dag i gram
      D9:
        window.wpObject?.tool_data?.data?.D9 != null
          ? window.wpObject.tool_data.data.D9
          : 0, // D9: Vikt vid födelse
      D10:
        window.wpObject?.tool_data?.data?.D10 != null
          ? window.wpObject.tool_data.data.D10
          : 0, // D10: Ålder vid förmedling
      D11:
        window.wpObject?.tool_data?.data?.D11 != null
          ? window.wpObject.tool_data.data.D11
          : 0, // D11: Önskad vikt vid inkalvning
    },
    resolver: yupResolver(schema),
  });
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = methods;
  const form = useRef(null);

  const [result, setResult] = useState({
    // results are thought of as number of places {property}

    E3:
      window.wpObject?.tool_data?.data?.E3 != null
        ? window.wpObject?.tool_data?.data?.E3
        : 0, // platser i sjukboxar krävs till mjölkkor
    E4:
      window.wpObject?.tool_data?.data?.E4 != null
        ? window.wpObject?.tool_data?.data?.E4
        : 0, // kalvningsboxar krävs
    E7:
      window.wpObject?.tool_data?.data?.E7 != null
        ? window.wpObject?.tool_data?.data?.E7
        : 0, // insatta eller sålda kvigor per år
    E10:
      window.wpObject?.tool_data?.data?.E10 != null
        ? window.wpObject?.tool_data?.data?.E10
        : 0, // kalvar (minus döda) säljs per år
    E11:
      window.wpObject?.tool_data?.data?.E11 != null
        ? window.wpObject?.tool_data?.data?.E11
        : 0, // månader inkalvningsålder

    D15:
      window.wpObject?.tool_data?.data?.D15 != null
        ? window.wpObject?.tool_data?.data?.D15
        : 0, // Vikt när djuret kommer till gruppen
    E15:
      window.wpObject?.tool_data?.data?.E15 != null
        ? window.wpObject?.tool_data?.data?.E15
        : 0, // Vikt när djuret kommer till gruppen
    F15:
      window.wpObject?.tool_data?.data?.F15 != null
        ? window.wpObject?.tool_data?.data?.F15
        : 0, // Vikt när djuret kommer till gruppen
    G15:
      window.wpObject?.tool_data?.data?.G15 != null
        ? window.wpObject?.tool_data?.data?.G15
        : 0, // Vikt när djuret kommer till gruppen
    H15:
      window.wpObject?.tool_data?.data?.H15 != null
        ? window.wpObject?.tool_data?.data?.H15
        : 0, // Vikt när djuret kommer till gruppen
    I15:
      window.wpObject?.tool_data?.data?.I15 != null
        ? window.wpObject?.tool_data?.data?.I15
        : 0, // Vikt när djuret kommer till gruppen

    D16:
      window.wpObject?.tool_data?.data?.D16 != null
        ? window.wpObject?.tool_data?.data?.D16
        : 0, // Vikt när djuret lämna boxen
    D17:
      window.wpObject?.tool_data?.data?.D17 != null
        ? window.wpObject?.tool_data?.data?.D17
        : 0, // Ålder vi flytt till nästa grupp
    D18:
      window.wpObject?.tool_data?.data?.D18 != null
        ? window.wpObject?.tool_data?.data?.D18
        : 0, // Behov antal platser i olika grupper

    E16:
      window.wpObject?.tool_data?.data?.E16 != null
        ? window.wpObject?.tool_data?.data?.E16
        : 0, // Vikt när djuret lämna boxen
    E17:
      window.wpObject?.tool_data?.data?.E17 != null
        ? window.wpObject?.tool_data?.data?.E17
        : 0, // Ålder vi flytt till nästa grupp
    E18:
      window.wpObject?.tool_data?.data?.E18 != null
        ? window.wpObject?.tool_data?.data?.E18
        : 0, // Behov antal platser i olika grupper

    F16:
      window.wpObject?.tool_data?.data?.F16 != null
        ? window.wpObject?.tool_data?.data?.F16
        : 0, // Vikt när djuret lämna boxen
    F17:
      window.wpObject?.tool_data?.data?.F17 != null
        ? window.wpObject?.tool_data?.data?.F17
        : 0, // Ålder vi flytt till nästa grupp
    F18:
      window.wpObject?.tool_data?.data?.F18 != null
        ? window.wpObject?.tool_data?.data?.F18
        : 0, // Behov antal platser i olika grupper

    G16:
      window.wpObject?.tool_data?.data?.G16 != null
        ? window.wpObject?.tool_data?.data?.G16
        : 0, // Vikt när djuret lämna boxen
    G17:
      window.wpObject?.tool_data?.data?.G17 != null
        ? window.wpObject?.tool_data?.data?.G17
        : 0, // Ålder vi flytt till nästa grupp
    G18:
      window.wpObject?.tool_data?.data?.G18 != null
        ? window.wpObject?.tool_data?.data?.G18
        : 0, // Behov antal platser i olika grupper

    H16:
      window.wpObject?.tool_data?.data?.H16 != null
        ? window.wpObject?.tool_data?.data?.H16
        : 0, // Vikt när djuret lämna boxen
    H17:
      window.wpObject?.tool_data?.data?.H17 != null
        ? window.wpObject?.tool_data?.data?.H17
        : 0, // Ålder vi flytt till nästa grupp
    H18:
      window.wpObject?.tool_data?.data?.H18 != null
        ? window.wpObject?.tool_data?.data?.H18
        : 0, // Behov antal platser i olika grupper

    I16:
      window.wpObject?.tool_data?.data?.I16 != null
        ? window.wpObject?.tool_data?.data?.I16
        : 0, // Vikt när djuret lämna boxen
    I17:
      window.wpObject?.tool_data?.data?.I17 != null
        ? window.wpObject?.tool_data?.data?.I17
        : 0, // Ålder vi flytt till nästa grupp
    I18:
      window.wpObject?.tool_data?.data?.I18 != null
        ? window.wpObject?.tool_data?.data?.I18
        : 0, // Behov antal platser i olika grupper

    J18:
      window.wpObject?.tool_data?.data?.J18 != null
        ? window.wpObject?.tool_data?.data?.J18
        : 0, // TOTALT Behov antal platser i olika grupper
    J19:
      window.wpObject?.tool_data?.data?.J19 != null
        ? window.wpObject?.tool_data?.data?.J19
        : 0, // Behov sjukboxar ungdjur
  });

  const sliderSettings = {
    arrows: false,
    dots: true,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  const handleCalculate = (formData) => {
    setFormErrors([]);

    if (window.wpObject.ajax_url == null) {
      return;
    }

    const requestData = new FormData(form.current);
    requestData.append(
      "action",
      "wt_ajax_tools_rekryteringsdjur_mjolkproduktion_1"
    );

    fetch(window.wpObject.ajax_url, {
      method: "POST",
      body: requestData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          setResult(response.data);
          setHasResults(true);
        } else {
          if ("errorsItemized" in response.data) {
            setFormErrors(response.data.errorsItemized, methods);
          }
          if ("errors" in response.data) {
            setServerMessages(response.data.errors.map((e) => e));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSaveResults = () => {
    if (window?.wpObject?.ajax_url == null) {
      return;
    }
    const requestData = new FormData(form.current);
    Object.keys(result)
      .filter((cell) => !requestData.has(cell))
      .map((rCell) => requestData.append(rCell, result[rCell]));
    requestData.append(
      "action",
      "wt_ajax_save_tool_rekryteringsdjur_mjolkproduktion_1"
    );

    fetch(window.wpObject.ajax_url, {
      method: "POST",
      body: requestData,
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        if (response.success) {
          setServerMessages([response.data.message]);
          if (window?.wpObject?.saved_results_url != null) {
            displaySavedAlert();
          }
        } else {
          if ("errorsItemized" in response.data) {
            setFormErrors(response.data.errorsItemized, methods);
          }
          if ("errors" in response.data) {
            setServerMessages(response.data.errors.map((e) => e));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className={"tool-base"}>
      <ToolHeader />

      <form ref={form} onSubmit={handleSubmit(handleCalculate)}>
        <HiddenToolFields />
        <ActionsBar
          hasResults={hasResults}
          onSave={handleSubmit(handleSaveResults)}
          onCalculate={handleSubmit(handleCalculate)}
          serverMessages={serverMessages}
        />

        <FormSection className="1">
          <Wrapper>
            <header>
              <h4>Behov av platser för kalvar och rekryteringsdjur</h4>
            </header>
            <InputColumn className="print-column">
              <div className="left-column">
                <FormElement
                  label="Antal kor - mjölkande och sinkor"
                  id="D3"
                  unit="kor"
                  register={register}
                  errors={errors?.D3}
                />
                <FormElement
                  label="Genomsnittligt antal kalvningar per månad"
                  id="D4"
                  unit="kalvningar"
                  register={register}
                  errors={errors?.D4}
                />
                <hr /> {/* ------------ */}
                <FormElement
                  label="Rekryterings %"
                  id="D6"
                  unit="%"
                  register={register}
                  errors={errors?.D6}
                />
                <FormElement
                  label="X-tra för oförutsedda händelser"
                  id="D7"
                  unit="%"
                  register={register}
                  errors={errors?.D7}
                />
                <FormElement
                  label="Genomsnittlig tillväxt per dag i gram"
                  id="D8"
                  unit="g per dag"
                  tooltip="Från födelse till kalvning"
                  register={register}
                  errors={errors?.D8}
                />
                <FormElement
                  label="Vikt vid födelse"
                  id="D9"
                  unit="kg"
                  register={register}
                  errors={errors?.D9}
                />
                <FormElement
                  label="Ålder vid förmedling"
                  id="D10"
                  unit="månader"
                  register={register}
                  errors={errors?.D10}
                />
                <FormElement
                  label="Önskad vikt vid inkalvning"
                  id="D11"
                  unit="kg"
                  register={register}
                  errors={errors?.D11}
                />
              </div>

              <div className="right-column">
                <div>
                  <FormElement
                    id="E3"
                    unit="platser i sjukboxar krävs till mjölkkor"
                    value={result.E3}
                    tooltip="Se djurskyddsbestämmelser"
                  />
                  <FormElement
                    id="E4"
                    unit="platser i kalvningsboxar krävs"
                    value={result.E4}
                    tooltip="Se djurskyddsbestämmelser"
                  />

                  <hr />
                  <hr />

                  <FormElement
                    id="E7"
                    unit="insatta eller sålda kvigor per år"
                    value={result.E7}
                  />

                  <hr />
                  <hr />

                  <FormElement
                    id="E10"
                    unit="kalvar som kan lämna gården per år"
                    value={result.E10}
                  />
                  <FormElement
                    id="E11"
                    unit="månader inkalvningsålder"
                    value={result.E11}
                  />
                </div>
              </div>
            </InputColumn>
          </Wrapper>
        </FormSection>

        <FormSection className="2">
          <Wrapper>
            <header>
              <h4 id="h4-with-dots">Minsta antal platser per grupp</h4>
            </header>
            <div className="table-box">
              <table className="first">
                <tr>
                  <td>
                    <label>Vikt när djuret kommer till gruppen</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="">Vikt när djuret lämnar gruppen</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="">Ålder vi flytt till nästa grupp</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="">
                      Behov antal platser i olika grupper
                      <Tooltip content="Se djurskyddsbestämmelser" />
                    </label>
                  </td>
                </tr>
              </table>

              <Slider {...sliderSettings} className="second">
                <SlickSliderItem
                  title={getValues("D9")}
                  row1={result.D15}
                  row2={result.D16}
                  row3={result.D17}
                  row4={result.D18}
                />
                <SlickSliderItem
                  title="90"
                  row1={result.E15}
                  row2={result.E16}
                  row3={result.E17}
                  row4={result.E18}
                />
                <SlickSliderItem
                  title="150"
                  row1={result.F15}
                  row2={result.F16}
                  row3={result.F17}
                  row4={result.F18}
                />
                <SlickSliderItem
                  title="250"
                  row1={result.G15}
                  row2={result.G16}
                  row3={result.G17}
                  row4={result.G18}
                />
                <SlickSliderItem
                  title="400"
                  row1={result.H15}
                  row2={result.H16}
                  row3={result.H17}
                  row4={result.H18}
                />
                <SlickSliderItem
                  title="600"
                  row1={result.I15}
                  row2={result.I16}
                  row3={result.I17}
                  row4={result.I18}
                />
              </Slider>
            </div>
          </Wrapper>
        </FormSection>

        <FormSection className="3">
          <Wrapper>
            <header className="column">
              <h4>Resultat</h4>
            </header>
            <div className="">
              <ResultSection final>
                <Label
                  className="column large-8 medium-6 small-6 xsmall-12"
                  label="Totalt antal"
                />
                <InputWrapper
                  className="column large-4 medium-6 small-6 xsmall-12"
                  title="platser"
                >
                  <ResultWrapper>{result.J18}</ResultWrapper>
                </InputWrapper>
              </ResultSection>
              <ResultSection final>
                <Label
                  className="column large-8 medium-6 small-6 xsmall-12"
                  label="Behov sjukboxar ungdjur"
                />
                <InputWrapper
                  className="column large-4 medium-6 small-6 xsmall-12"
                  title="platser"
                >
                  <ResultWrapper>{result.J19}</ResultWrapper>
                </InputWrapper>
              </ResultSection>
            </div>
          </Wrapper>
        </FormSection>

        <ActionsBar
          hasResults={hasResults}
          onSave={handleSubmit(handleSaveResults)}
          onCalculate={handleSubmit(handleCalculate)}
          serverMessages={serverMessages}
        />
      </form>
    </div>
  );
}

function SlickSliderItem({ title, row1, row2, row3, row4 }) {
  return (
    <table className="slider-item-table">
      <thead>
        <tr>
          <th>{title}kg</th>
        </tr>
      </thead>
      <tbody>
        {/* Row 1 -------------- */}
        <tr>
          <td>
            <label>Vikt när djuret kommer till gruppen</label>
            <FormInput fullWidth value={row1} unit={"kg"} />
          </td>
        </tr>

        {/* Row 2 -------------- */}
        <tr>
          <td>
            <label>Vikt när djuret lämnar gruppen</label>
            <FormInput fullWidth value={row2} unit={"kg"} />
          </td>
        </tr>

        {/* Row 3 -------------- */}
        <tr>
          <td>
            <label>Ålder vi flytt till nästa grupp</label>
            <FormInput fullWidth value={row3} unit={"månader"} />
          </td>
        </tr>

        {/* Row 4 -------------- */}
        <tr>
          <td>
            <label>
              Behov antal platser i olika grupper
              <Tooltip content="Se djurskyddsbestämmelser" />
            </label>
            <FormInput fullWidth value={row4} unit={"stycken"} />
          </td>
        </tr>
      </tbody>
    </table>
  );
}
